import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Modal from './modules/Modal';
import Routing from './routing';
import { Provider } from 'react-redux';
import store from './redux/store';

function App() {
	return (
		<div className="App">
			<Provider store={store}>
				<Routing />
				<Modal />
				<ToastContainer autoClose={false} className="toast-container" />
			</Provider>
		</div>
	);
}

ReactDOM.render(<App />, document.getElementById('root'));
